/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createBaseClientRepresentationFromDiscriminatorValue, serializeBaseClientRepresentation } from '../../../../../models/index.js';
// @ts-ignore
import { VersionItemRequestBuilderRequestsMetadata } from './item/index.js';
/**
 * Uri template for the request builder.
 */
export const WithVersionItemRequestBuilderUriTemplate = "{+baseurl}/admin/api/{realmName}/clients/{version}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithVersionItemRequestBuilderNavigationMetadata = {
    byId: {
        requestsMetadata: VersionItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["id"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithVersionItemRequestBuilderRequestsMetadata = {
    get: {
        uriTemplate: WithVersionItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "sendCollection",
        responseBodyFactory: createBaseClientRepresentationFromDiscriminatorValue,
    },
    post: {
        uriTemplate: WithVersionItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "send",
        responseBodyFactory: createBaseClientRepresentationFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeBaseClientRepresentation,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=index.js.map